<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="searchFormData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>


<script>
  import download from '@/utils/download'

  import tablePage from '@/components/page/table.vue'               //table封装组件
  import FORM from '@/components/page/form.vue'

  import URL from '@/views/emg/util/url'

  export default {
    name: 'list',

    components: {
      tablePage,
      FORM
    },

    data () {
      return {
        queryData:{},

        /*from查询表单*/
        searchFormData:{
          hasLable: true,
          cols: [
              { title: this.$t("emg.common.queryTime"), field: 'statsDate', type: 6, noTable: true },
              {
                  title: this.$t("emg.common.businessType"),
                  field: 'businessType',
                  type: 2,
                  placeholder: this.$t("emg.common.businessTypePlaceholder"),
                  data: '',
                  optionList: [
                      { key: '', value: '' }, // 空白選項
                      { key: 'default', value: this.$t("emg.common.businessTypeGM") },
                      { key: 'cx', value: this.$t("emg.common.businessTypeCX") },
                      { key: 'gmcx', value: this.$t("emg.common.businessTypeGMCX") },
                  ]
              },
              { click: this.$t("common.search") },
              { click: this.$t("common.reset") },
              { click: this.$t("emg.bt.export") }
          ]
        },

        /*table生成*/
        pageData: {
          queryUrl: URL.dden.stats,
          sequence: false,
          cols: [
              { title: this.$t("emg.common.sequence"), field: 'id' },
              { title: this.$t("emg.statsCommon.statsDate"), field: 'statsDate' },
              { title: this.$t("emg.common.businessType"), field: 'businessType' },
              { title: this.$t("emg.statsCommon.statsSize"), field: 'statsSize' },
              { title: this.$t("emg.statsCommon.statsSmallAmountTransfer"), field: 'statsSmallAmountTransfer' },
              { title: this.$t("emg.statsCommon.statsLargeAmountTransfer"), field: 'statsLargeAmountTransfer' },
              { title: this.$t("emg.statsCommon.statsAlipay"), field: 'statsAlipay' },
              { title: this.$t("emg.statsCommon.statsUSDT"), field: 'statsUSDT' },
              { title: this.$t("emg.statsCommon.statsDigitalRMB"), field: 'statsDigitalRMB' },
              { title: this.$t("emg.statsCommon.statsCloudQuickPass"), field: 'statsCloudQuickPass' },
              { title: this.$t("emg.statsCommon.statsCardCode"), field: 'statsCardCode' },
              { title: this.$t("emg.statsCommon.statsWeChat"), field: 'statsWeChat' },
              { title: this.$t("emg.statsCommon.statsYunPayTransfer"), field: 'statsYunPayTransfer' },
              { title: this.$t("emg.statsCommon.statsOthers"), field: 'statsOthers' },
              { title: this.$t("emg.statsCommon.statsDiscrepancyAmountCNY"), field: 'statsDiscrepancyAmountCNY' },
              { title: this.$t("emg.statsCommon.statsDiscrepancyAmountUSD"), field: 'statsDiscrepancyAmountUSD' },
              { title: this.$t("emg.statsCommon.statsDiscrepancyAmountOthers"), field: 'statsDiscrepancyAmountOthers' },
              { title: this.$t("emg.statsCommon.statsTotalProcessingTime"), field: 'statsTotalProcessingTime' },             
              { title: this.$t("emg.statsCommon.statsAverageProcessingTime"), field: 'statsAverageProcessingTime' },
          ]
        }
      }
    },

    methods: {
              /*查詢表單按鈕點擊事件*/
      formclick(clickName, data){

        if(data.statsDate!=undefined &&data.statsDate.indexOf(",")!=-1){
            let timeArr=data.statsDate.split(",");
            data.endTime=timeArr[1];
            data.startTime=timeArr[0];
            data.statsDate = null;
        }

        // --- 根據按鈕名稱分發任務 ---
        if (clickName === this.$t("common.search")) {
            this.queryData = data;
            this.$refs.childTable.defaultGetData(data);
        } else if (clickName === this.$t("emg.bt.export")) {
            download.exportExcel(URL.dden.downloadStats, data, this.$t('emg.statsMsg.exportListTitle'));
        } else if (clickName === this.$t("common.reset")) {
            this.handleReset();
        }
      },

      handleReset() {
        // 1. 重設搜尋表單的資料
        // Create a new object to ensure reactivity
        const newCols = this.searchFormData.cols.map(col => {
            if (col.field) {
                return { ...col, data: null };
            }
            return col;
        });
        this.searchFormData.cols = newCols;

        // 2. 清空父組件中的所有相關資料
        this.queryData = {};

        // 3. 重新載入表格，傳遞一個空物件來獲取所有資料
        this.$refs.childTable.defaultGetData({});
        
        this.showGlobalSuccess(this.$t('emg.msg.resetSuccess'));
      },

      showGlobalSuccess(message) {
        this.$message.success(message);
      },

      showGlobalError(message) {
        this.$message.error(message);
      }
    },

    mounted() {
      // 組件掛載後立即執行初始查詢，確保在任何語言下行為都一致。
      // 我們傳遞一個空物件來獲取所有記錄。
      this.$refs.childTable.defaultGetData({});
    }
  }
</script>